angular.module('zc.zenclerkS')
  .component('zcsRealtimeBarChart', {
    templateUrl: '/templates/zenclerk_s/directives/realtime/bar-chart.html',
    bindings: {
      /** data should be in following format:
       * [
       *   {
       *      start: Date,
       *      end: Date,
       *      historyCount: Number
       *   }
       * ]
       */
      data: '<',
      showDataMinutes: '<',
      isPaused: '<',
      project: '<',
    },
    controller: zcsRealtimeBarChartController,
  });

zcsRealtimeBarChartController.$inject = ['$document', '$translate', '$element', '$interval', '$scope', '$timeout'];
function zcsRealtimeBarChartController($document, $translate, $element, $interval, $scope, $timeout) {
  const vm = this;
  const region = vm.project.region;
  const SHOW_DATA_MINUTES = vm.showDataMinutes || 30;
  const HEIGHT = 150;
  const REDRAW_INTERVAL = 2000;
  const paddingBottom = 20;
  const paddingLeft = 20;
  const paddingRight = 20;
  const normalFill = 'rgba(29, 213, 163, 0.5)';
  const activeFill = 'rgba(29, 153, 124, 0.5)';
  let WIDTH = 280;
  let svg;
  let xScale;
  let yScale;
  let xAxis;
  let tooltip;
  let redrawInterval;
  let isInitialized = false;
  let renderedOnceAfterPause = false;

  vm.$onInit = onInit;
  vm.$onChanges = onChanges;

  function onInit() {
    $timeout(() => {
      WIDTH = $element.parent().width();
      createSvg();
      isInitialized = true;
      if(vm.data) {
        onChanges();
      }
    });

    $document.on('resize', () => {
      WIDTH = $element.width();
      createSvg();
    });


    $scope.$on('$destroy', () => {
      $interval.cancel(redrawInterval);
    });
  }

  function onChanges(obj) {
    const currentValue = _.get(obj, 'data.currentValue', 0);
    const previousValue = _.get(obj, 'data.previousValue', 1);
    const valuesDiffer = !_.isEqual(currentValue, previousValue);
    if(isInitialized && vm.data && valuesDiffer) {
      if(vm.isPaused && renderedOnceAfterPause) {
        return;
      }

      updateBars();

      // Prevent generating more and more intervals
      if(!redrawInterval) {
        redrawInterval = $interval(() => {
          if(vm.isPaused) {
            $interval.cancel(redrawInterval);
            redrawInterval = null;
            return;
          }

          renderedOnceAfterPause = false;
          vm.currentTime = moment.tz(region).add(1, 'minute').startOf('minute').toDate();

          updateBars();
        }, REDRAW_INTERVAL);
      }
    }
  }

  function createSvg() {
    if(!svg) {
      svg = d3.select($element.find('.realtime-bar-chart')[0]);
    }

    svg.attr('height', HEIGHT).attr('width', WIDTH);
    xScale = d3.scale.linear()
      .range([WIDTH - paddingRight, paddingLeft]);
    yScale = d3.scale.linear()
      .range([0, HEIGHT - paddingBottom]);

    xAxis = d3.svg.axis()
      .scale(xScale)
      .orient('bottom')
      .tickValues([1, 0])
      .tickFormat(d => {
        if(d === 1) {
          return $translate.instant('directives.common.minutesAgo', { minute: SHOW_DATA_MINUTES });
        } else if(d === 0) {
          return $translate.instant('directives.common.now');
        }
        return d;
      });

    svg.append('g')
      .attr('transform', `translate(0,${HEIGHT - paddingBottom})`)
      .attr('class', 'axis')
      .call(xAxis);

    createTooltip();
  }

  function createTooltip() {
    tooltip = $('<div class="nvtooltip" style="display:none"></div>');
    $element.find('.realtime-bar-chart-container').append(tooltip);
  }

  function showTooltip(d) {
    const pos = d3.mouse(this);
    const x = pos[0];
    const y = pos[1];
    const yOffset = 10;
    let xOffset = 30;

    tooltip.html(`
      <table>
        <thead>
          <tr>
            <td colspan="3">${moment(d.start).format('HH:mm')} ~ ${moment(d.end).format('HH:mm')}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="legend-color-guide">
              <div style="background-color:${normalFill}"></div>
            </td>
            <td class="key">${$translate.instant('directives.realtime.barChart.numberOfPageViews')}</td>
            <td class="value">${d.historyCount}</td>
          </tr>
        </tbody>
      </table>
    `);

    const chartContainerWidth = $element.find('.realtime-bar-chart-container').width();
    const borderWidth = 2; //left border px + right border px
    const tooltipWidth = $element.find('.realtime-bar-chart-container .nvtooltip').innerWidth() + borderWidth;

    if(x + tooltipWidth > chartContainerWidth) {
      xOffset = -tooltipWidth;
    }

    tooltip
      .css('left', (x + xOffset) + 'px')
      .css('top', (y - yOffset) + 'px')
      .css('opacity', 1)
      .css('display', 'block');
  }

  function hideTooltip(e) {
    tooltip.text('');
    tooltip.css('display', 'none');
  }

  function updateBars() {
    xScale.domain([0, (SHOW_DATA_MINUTES + 1) * 60]);
    const historyCounts = _.map(vm.data, d => d.historyCount);
    yScale.domain([0, _.max(historyCounts)]);

    const historyCountBars = svg.selectAll('.bar-history-count')
      .data(vm.data, d => d.end);


    // enter for new ones
    historyCountBars
      .enter()
      .append('rect')
      .attr('class', 'bar-history-count')
      .style('fill', normalFill)
      .style('stroke', 'rgb(29, 213, 163)')
      .attr('x', d => xScale(moment.tz(vm.currentTime, region).diff(moment.tz(d.start, region), 'seconds')))
      .attr('y', HEIGHT - paddingBottom)
      .attr('width', d => ((WIDTH - paddingLeft - paddingRight) / SHOW_DATA_MINUTES) / 3 * 2)
      .attr('height', 0)
      .on('mouseover', showTooltip)
      .on('mouseout', hideTooltip);

    // update
    historyCountBars
      .transition()
      .duration(1000)
      .delay(200)
      .attr('x', d => xScale(moment.tz(vm.currentTime, region).diff(moment.tz(d.start, region), 'seconds')))
      .attr('y', d => {
        if(HEIGHT - paddingBottom - yScale(d.historyCount) < 0) {
          return HEIGHT - paddingBottom;
        }
        return HEIGHT - paddingBottom - yScale(d.historyCount);
      })
      .attr('width', d => (WIDTH / SHOW_DATA_MINUTES) / 3 * 2)
      .attr('height', d => {
        if(yScale(d.historyCount) < 0) {
          return 0;
        }
        return yScale(d.historyCount);
      })
      .style('fill', (d, i) => {
        if(i === 0) {
          return activeFill;
        }
        return normalFill;
      });

    if(vm.isPaused) {
      renderedOnceAfterPause = true;
    } else {
      renderedOnceAfterPause = false;
    }

    historyCountBars
      .exit()
      .transition()
      .duration(200)
      .attr('height', 0)
      .attr('y', HEIGHT - paddingBottom)
      .transition()
      .remove();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/realtime/bar-chart.js